export default "__VITE_ASSET__INlXnljW__"